module.exports = __webpack_public_path__ + "img/cellarBanner.3e279b02.jpg";